import { createRoute } from '@/utils/routing'

export const WORKING_DAYS_CALENDAR_ROUTE = 'working-days'

export function createWorkingDaysCalendarRoute (options = {}) {
  return createRoute(WORKING_DAYS_CALENDAR_ROUTE, options)
}
